"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPwhHydraulicBalancingStatuses = exports.selectActiveSiteId = exports.getActiveSiteId = void 0;
var _constants = require("../../../utils/constants");
/** @deprecated getActiveSiteId use selectActiveSiteId */
const getActiveSiteId = _ref => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref;
  return (sites === null || sites === void 0 ? void 0 : sites.activeSiteId) || null;
};
exports.getActiveSiteId = getActiveSiteId;
const selectActiveSiteId = _ref2 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref2;
  return (sites === null || sites === void 0 ? void 0 : sites.activeSiteId) || null;
};
exports.selectActiveSiteId = selectActiveSiteId;
const selectPwhHydraulicBalancingStatuses = _ref3 => {
  let {
    [_constants.packageKey]: {
      sites
    } = {}
  } = _ref3;
  return (sites === null || sites === void 0 ? void 0 : sites.pwhHydraulicBalancingStatuses) || [];
};
exports.selectPwhHydraulicBalancingStatuses = selectPwhHydraulicBalancingStatuses;